import { gql } from "@apollo/client";

const CREATE_NOVEDAD_VISITA = gql`
    mutation createNovedadVisita($input: AddNovedadVisitaInput!) {
        createNovedadVisita(input: $input) {
            idNovedad
        }
    }
`;

export default CREATE_NOVEDAD_VISITA;